var r=200,a=400;export{r as PER_PAGE,a as SCROLL_THRESHOLD};
